/* src/app/pages/project/map/repository/import-wizard/components/geospatial/step1-preview/import-wizard-geospatial-preview.component.scss */
:host {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}
#map {
  width: 100%;
  height: 100%;
  min-height: 400px;
  background: #414141;
}
.geospatial-preview-container {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: 1fr;
  gap: 0 1rem;
  padding: 1rem;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
  min-height: 0;
}
.preview-map-container {
  grid-column: span 2;
  border: 1px solid #333;
  border-radius: 12px;
  height: 45%;
  overflow: hidden;
}
.preview-feature-container {
  display: flex;
  flex-direction: column;
  grid-column: span 5;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
.preview-table-title {
  font-size: 15px;
  color: #9e9e9e;
  margin-bottom: 0.3rem;
}
.feature-item {
  padding: 0.5rem;
  border-bottom: 1px solid #ddd;
}
.feature-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.table-wrapper {
  border: 1px solid rgb(51, 51, 51);
  border-radius: 10px;
  overflow: auto;
  flex: 1;
}
.search-input-dimension {
  margin-bottom: 12px;
  max-width: 450px;
}
.button-container {
  display: flex;
  justify-content: flex-end;
  gap: 0 1rem;
  margin-top: 1rem;
}
.button-container > button {
  background: var(--color-primary);
  color: var(--color-text);
  border: none;
  border-radius: 6px;
  padding: 8px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  width: fit-content;
  height: fit-content;
  transition: all 0.2s ease;
}
.button-container > button:hover {
  background: var(--color-primary);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.3);
}
.button-container > button:active {
  transform: translateY(0);
}
.button-container > button.secondary {
  background: #444444;
  color: #ffffff;
}
.button-container > button.secondary:hover {
  background: #3d3d3d;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}
.no-features-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
  text-align: center;
  gap: 8px;
  margin-bottom: auto;
  animation: fadeCascade 320ms ease forwards;
}
.status-icon {
  font-family: "Material Icons";
  font-size: 42px;
  line-height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.warning-icon {
  color: var(--color-primary);
}
.warning-title {
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
}
.warning-description {
  font-size: 13px;
  color: #929292;
  max-width: 360px;
}
.mat-mdc-table {
  background: transparent !important;
}
.mat-mdc-header-row,
.mat-mdc-header-cell {
  background: rgb(51, 51, 51) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
}
.mat-mdc-row,
.mat-mdc-cell {
  background: transparent !important;
  color: var(--color-text);
}
.mat-mdc-row:hover {
  background: rgba(255, 255, 255, 0.04) !important;
}
.mat-elevation-z8 {
  box-shadow: none !important;
}
.mat-mdc-cell {
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}
.mat-mdc-row:last-child .mat-mdc-cell {
  border-bottom: none;
}
.mat-mdc-paginator {
  background: transparent;
  color: var(--color-text) !important;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}
.mat-mdc-paginator .mat-mdc-icon-button,
.mat-mdc-paginator .mat-mdc-select-value {
  color: var(--color-text);
}
:host ::ng-deep .mat-mdc-paginator-icon {
  fill: var(--color-text) !important;
}
::ng-deep .html-content table {
  background: none !important;
  border-collapse: collapse !important;
  width: 100% !important;
}
::ng-deep .html-content tr,
::ng-deep .html-content td {
  background: none !important;
  padding: 8px !important;
  border: 1px solid #ddd !important;
}
::ng-deep .html-content tr:nth-child(even) {
  background: none !important;
}
::ng-deep .html-content tr[style*=background] {
  background: none !important;
}
::ng-deep .html-content td[bgcolor],
::ng-deep .html-content tr[bgcolor] {
  background: none !important;
}
/*# sourceMappingURL=import-wizard-geospatial-preview.component-7VBYIAYC.css.map */
